import router from '@/main/router';
import { IBehavior } from '@/interfaces/Behavior';

import { isValid } from '@/helpers/values';
import { getUUIDWeight, defineSegmentByWeight } from '@/helpers/ab';

export default {
  uuid: (state: IBehavior) => state.uuid.getSession().value,
  alreadyOfferLoaded: (state: IBehavior) => state.checkoutLoaded.getSession().value,
  paymentMethodSelected: (state: IBehavior) => state.paymentMethodSelected.getSession().value,
  offerSelected: (state: IBehavior) => state.offerSelected.getSession().value,
  isOfferAlreadyLoaded: (state: IBehavior, getters: any) => {
    return (offerHash: string) => {
      const currentOfferLoaded = offerHash;
      const alreadyOfferLoaded = getters.alreadyOfferLoaded;

      if (!isValid(alreadyOfferLoaded)) {
        return false;
      }

      return alreadyOfferLoaded === currentOfferLoaded;
    };
  },
  isCaptchaValid: (state: IBehavior) => state.isCaptchaValid,
  isDeliveryAddressValid: (state: IBehavior) => state.isDeliveryAddressValid,
  purchaseResponse: (state: IBehavior) => JSON.parse(state.purchaseResponse.getSession().value),
  ABSegmentByUUID: (state: IBehavior) => {
    return (uuid: string) => {
      return defineSegmentByWeight(getUUIDWeight(uuid), state.ab.segments);
    };
  },
};
